<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

// PROPS
defineProps({
    back: { type: Object as PropType<RouteLocationRaw>, default: undefined },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const localePath = useLocalePath();
</script>

<template>
    <nav class="sticky inset-x-0 top-0 z-40 flex w-full items-center justify-center bg-white ring-1 ring-neutral-300">
        <BaseWidthContainer as="header" class="relative z-40 flex h-(--header-height) flex-row items-center justify-center">
            <UButton v-if="back" :to="localePath(back)" class="absolute left-6 xl:left-14" color="neutral" icon="lucide:arrow-left" variant="ghost">
                <span class="hidden md:inline">{{ tt('common.back') }}</span>
            </UButton>
            <SvgoFleequidLogo class="text-highlighted inline h-[20px]" :font-controlled="false" />
            <LangSwitch class="absolute right-6 xl:right-14" />
        </BaseWidthContainer>
    </nav>
</template>
